import React, { PropsWithChildren } from 'react';

import { Alert } from '@zapier/design-system';

import { useDismissable } from 'app/developer-v3/hooks';

type Props = PropsWithChildren<{ persistId: string }>;

export default function PartnerSandboxAlert({ children, persistId }: Props) {
  const { dismiss, isVisible } = useDismissable({ persistId });

  return isVisible ? (
    <Alert
      onDismiss={persistId ? dismiss : undefined}
      title="Zapier Partner Sandbox"
    >
      {children}
    </Alert>
  ) : null;
}
